import React, { useEffect, type FC } from 'react'

import { useIntl } from 'react-intl'

import { useRecoilCallback, useRecoilValue } from 'recoil'

import { Loading, ToastContainer, Tooltip } from 'mailup-web-components'

import Page from 'Containers/Page'

import Header from 'Pages/ImportFattureInCloud/components/Header'

import {
  initPageCallback,
  resetPageCallback,
} from 'Pages/ImportFattureInCloud/recoil/callbacks'
import { importState } from 'Pages/ImportFattureInCloud/recoil/state'

const ImportFattureInCloud: FC = () => {
  const intl = useIntl()

  const { loading } = useRecoilValue(importState)

  const initPage = useRecoilCallback(initPageCallback, [])
  const resetPage = useRecoilCallback(resetPageCallback, [])

  const init = (): void => {
    void initPage()
  }

  useEffect(() => {
    void initPage()

    return () => {
      void resetPage()
    }
  }, [])

  return (
    <>
      <Tooltip />
      <ToastContainer />

      <Header />
      <Page onReload={init}>
        <Loading
          open={loading}
          text={intl.formatMessage({
            id: 'Load.ImportFattureInCloud.ImportClientsInProgress',
          })}
        />
      </Page>
    </>
  )
}

export default ImportFattureInCloud
